import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if the request URL is relative and start with api
    const isRelative = !/^https?:\/\//i.test(request.url);
    if (isRelative && request.url.startsWith("api")) {
      // make sure the url is not already starting or ending with a slash
      request = request.clone({url: `${environment.apiUrl.replace(/\/+$/, '')}/${request.url.replace(/^\/+/, '')}`});
    }
    return next.handle(request);
  }
}
